import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Collapsed from "../../general/collapsed";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";
import numeral from "numeral";
import { renderStatus } from "../../../libs/deadlinesUtils";

const History = props => {
  const { isFullscreenOverlay } = props;
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);

  const historyLine = useSelector(state => state.deadlinesDetail.subjective.parentDeadlines || []);

  const renderAmountWithStyle = totalAmount => {
    const iconTitle = totalAmount > 0 ? "plus-circle" : "minus-circle";
    const iconColor = totalAmount > 0 ? "#0d6c80" : "#c53090";
    return (
      <>
        <FontAwesomeIcon
          style={{ color: iconColor, marginRight: "5px" }}
          icon={["fas", iconTitle]}
        />{" "}
        {numeral(Math.abs(totalAmount)).format("0,0.00")} €
      </>
    );
  };

  const renderContent = () => {
    return (
      <section style={{ marginBottom: "32px" }}>
        <header
          className="tableFluid"
          style={{ color: "#005075", borderBottom: "1px solid #d8d8d8" }}
        >
          <div className="colFluid" style={{ flex: "0 0 auto", width: "48px" }}>
            {" "}
          </div>
          <div
            className="colFluid"
            style={{ width: "110px", flex: "0 0 auto" }}
          >
            Data
          </div>
          <div className="colFluid">Descrizione</div>
          <div
            className="colFluid"
            style={{ width: "110px", flex: "0 0 auto" }}
          >
            Importo
          </div>
          <div
            className="colFluid"
            style={{ width: "110px", flex: "0 0 auto" }}
          >
          </div>
          <div className="colFluid" style={{ flex: "0 0 auto", width: "48px" }}>
            {" "}
          </div>
        </header>
        {historyLine.map((el, index) => {
          return (
            <div
              key={`historyLine${index}`}
              className="rowFluid"
              style={{ cursor: "pointer" }}
              onClick={e => navigate("/scadenza/" + el.id)}
            >
              <div
                className="colFluid"
                style={{ flex: "0 0 auto", width: "48px" }}
              >
                <FontAwesomeIcon
                  style={{
                    color: "#000000",
                    fontSize: "16px",
                    marginRight: "4px",
                    cursor: "pointer"
                  }}
                  icon={["far", "alarm-clock"]}
                />
              </div>
              <div
                className="colFluid"
                style={{ width: "110px", flex: "0 0 auto" }}
              >
                {moment(el.date).format(DATE_FORMAT_FOR_DISPLAY)}
              </div>
              <div className="colFluid">
                {el.description.title + " " + (el.description.details ? el.description.details : "")}
              </div>
              <div
                className="colFluid"
                style={{ width: "110px", flex: "0 0 auto" }}
              >
                {renderAmountWithStyle(el.totalAmount)}
              </div>
              <div
                className="colFluid"
                style={{ width: "110px", flex: "0 0 auto" }}
              >
                {renderStatus(el)}
              </div>
              <div
                className="colFluid"
                style={{ flex: "0 0 auto", width: "48px" }}
              >
                {!isFullscreenOverlay && <FontAwesomeIcon
                  style={{
                    color: "#0090d1",
                    cursor: "pointer",
                    fontSize: "16px",
                    margin: "0 16px"
                  }}
                  icon={["fal", "arrow-right"]}
                />}
              </div>
            </div>
          );
        })}
      </section>
    );
  };

  return (
    historyLine.length > 0 && (
      <Collapsed
        key={"history"}
        isCollapsed={collapsed}
        onClick={e => {
          setCollapsed(!collapsed);
        }}
        title={"Storico"}
      >
        {renderContent()}
      </Collapsed>
    )
  );
};

export default History;
